__turbopack_context__.v({
  "color": "placeholderText-module-scss-module__tG9XYa__color",
  "placedholderText": "placeholderText-module-scss-module__tG9XYa__placedholderText",
  "textBar": "placeholderText-module-scss-module__tG9XYa__textBar",
});
